<template lang="pug">
yz-filter-menu(label="Stock" :is-active="!!selectedOption" :display-value="displayValue" @clear="onClear" @apply="onApply" :disable-apply="disabledButton")
  .pa-4
    y-select.mb-2(v-model="option" :items="options" item-value="id" item-text="name" small attach)
    .d-flex.align-start
      v-icon.mx-2(size="16" color="primary") $yzi-corner-down-right
      v-text-field.round-xl(v-model="value" hide-details outlined dense placeholder="Enter value" type="number")
      template(v-if="option === 'between'")
        .text-xs.mt-3.mx-2.neutral500--text to
        v-text-field.round-xl(v-model="endValue" hide-details outlined dense placeholder="Enter value" type="number")
</template>

<script>
export default {
  props: {
    filter: { type: Object, default: () => ({}) },
    checkInitialValue: { type: Boolean, default: false }
  },
  data: () => ({
    option: 'stock',
    value: null,
    endValue: null,
    options: [
      { id: 'stock', name: 'Is' },
      { id: 'stock__ne', name: 'Is not' },
      { id: 'stock__lt', name: 'Less than' },
      { id: 'stock__gt', name: 'More than' },
      { id: 'between', name: 'Is between' }
    ],
    selectedOption: null,
    selectedValue: null,
    selectedEndValue: null
  }),
  computed: {
    displayValue () {
      if (!this.selectedOption) return ''
      const opt = this.options.find(o => o.id === this.selectedOption)
      const name = opt ? opt.name : ''
      if (this.selectedOption === 'between') return `${name} ${this.selectedValue}-${this.selectedEndValue}`
      return `${name} ${this.selectedValue}`
    },
    disabledButton () {
      if (this.option === 'between' && (!this.value || !this.endValue)) return true
      return !this.value
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) this.clearData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue && this.filter.key) {
        this.selectedOption = this.filter.key
        this.option = this.filter.key
        if (this.filter.key === 'between' && this.filter.value.length) {
          this.value = this.filter.value[0].value
          this.endValue = this.filter.value[1].value
          this.selectedValue = this.value
          this.selectedEndValue = this.endValue
        } else {
          this.value = this.filter.value
          this.selectedValue = this.value
        }
      }
    },
    onClear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedOption = null
      this.value = null
      this.endValue = null
      this.selectedValue = null
      this.selectedEndValue = null
    },
    onApply () {
      this.selectedOption = this.option
      this.selectedValue = this.value
      this.selectedEndValue = this.endValue
      let filter = { key: this.option, value: this.value }
      if (this.option === 'between') {
        filter = {
          key: this.option,
          value: [
            { key: 'stock__gte', value: this.value },
            { key: 'stock__lte', value: this.endValue }
          ]
        }
      }
      this.$emit('update:filter', filter)
    }
  }
}
</script>
